import { REVIEW_STATES, TReviewStates } from '@/constants';
import { ReviewStateEnum } from '@/features/segments/types';

import { BroadcastScheduleProgramHeaderButtonExtra } from './components/BroadcastScheduleProgramHeaderButtonExtra';
import { BroadcastScheduleProgramHeaderButtonFiltersChannelType } from './components/BroadcastScheduleProgramHeaderButtonFiltersChannelType';
import { BroadcastScheduleProgramHeaderButtonFiltersReview } from './components/BroadcastScheduleProgramHeaderButtonFiltersReview';
import { BroadcastScheduleProgramHeaderCardList } from './components/BroadcastScheduleProgramHeaderCardList';

type TBroadcastScheduleProgramHeaderButtonFiltersProps<T = ReviewStateEnum> = {
  segments?: boolean;
  reviewStates?: TReviewStates<T>[];
  isLoading?: boolean;
  queryKey?: readonly unknown[];
};

export function BroadcastScheduleProgramHeaderButtonFilters<T = ReviewStateEnum>({
  segments,
  reviewStates = REVIEW_STATES as unknown as TReviewStates<T>[],
  isLoading,
  queryKey,
}: TBroadcastScheduleProgramHeaderButtonFiltersProps<T>) {
  return (
    <div className="flex flex-1 flex-wrap justify-between gap-2">
      <div className="flex flex-wrap items-center gap-2 sm:gap-8" id="segments-fast-filters">
        <BroadcastScheduleProgramHeaderButtonFiltersReview reviewStates={reviewStates} />
        {segments && <BroadcastScheduleProgramHeaderButtonFiltersChannelType />}
        {queryKey && (
          <BroadcastScheduleProgramHeaderButtonExtra
            isLoading={isLoading || false}
            queryKey={queryKey}
          />
        )}
      </div>
      <BroadcastScheduleProgramHeaderCardList />
    </div>
  );
}
